import { render, staticRenderFns } from "./addLabel.vue?vue&type=template&id=27efd15e&scoped=true"
import script from "./addLabel.vue?vue&type=script&lang=js"
export * from "./addLabel.vue?vue&type=script&lang=js"
import style0 from "./addLabel.vue?vue&type=style&index=0&id=27efd15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27efd15e",
  null
  
)

export default component.exports